import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 9.752c-.6 0-1 .39-1 .976v7.82c0 .588-.4.979-1 .979H3c-.6 0-1-.39-1-.978v-7.82c0-.586-.4-.977-1-.977s-1 .39-1 .976v7.82c0 1.664 1.3 2.935 3 2.935h12c1.7 0 3-1.271 3-2.934v-7.82c0-.586-.4-.977-1-.977M5.7 5.548 8 3.3v10.362c0 .585.4.977 1 .977s1-.391 1-.977V3.3l2.3 2.248c.2.194.4.292.7.292s.5-.098.7-.292a.93.93 0 0 0 0-1.37l-4-3.91C9.6.171 9.5.074 9.4.074c-.2-.098-.5-.098-.8 0-.1.097-.2.097-.3.195l-4 3.91a.93.93 0 0 0 0 1.369c.4.39 1 .39 1.4 0"
    }, null, -1)
  ]))]))
}
export default { render: render }